import { Component, OnInit } from '@angular/core';
// import { InitService } from 'src/app/parsers/init.service';
// import { Config } from 'src/app/enums';
// import { IBottombarConfig, IApplicationToolsConfig } from 'src/app/models/config/bottombar.config';
// import { AppStateService } from '../../../shared/services/app-state.service';
// import { IAppState, IBottombarState } from 'src/app/models';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-bottom-bar',
  templateUrl: './bottom-bar.component.html',
  styleUrls: ['./bottom-bar.component.scss']
})
export class BottomBarComponent implements OnInit {
  // bottombarConfig: IBottombarConfig;
  // appState: IAppState;
  // bottombarState: IBottombarState;

  subscriptions: Subscription[] = [];
  
  bottomOptions: any = [];
  selectedApplication: string;
  activeMenu: string | null = null;
  lindex = -1;

  constructor(
    // private initSrv : InitService,
    // private appStateSrv : AppStateService
    ) { }

  ngOnInit() {
      // this.loadBottombarConfig();
      // this.subscribeEvents();
  }

  // subscribeEvents(){
  //   const bottomBarRef = this.appStateSrv.bottombarStateRef.subscribe((updateBottomBarState: IBottombarState) => {
  //     this.bottombarState = updateBottomBarState;
  //   });
  //   this.subscriptions.push(bottomBarRef);

  // }

  // loadBottombarConfig(){
  //   this.bottombarConfig = this.initSrv.getConfig(Config.BOTTOMBAR_CONFIG);
  //   console.log(this.bottombarConfig);
  //   this.bottomOptions = this.bottombarConfig.applications.filter(app=> app.components.includes("ALL"));
  //   this.selectedApplication = "-1";
  //   let app = this.bottombarConfig.applications.findIndex((app) => app.name === this.selectedApplication);
  //   if( app !== -1) {
  //     this.updateBottombarState(this.bottombarConfig.applications[app]);
  //   }
  // }

  // updateBottombarState(app: IApplicationToolsConfig) {
  //   this.bottombarState = this.appStateSrv.getBottombarState();
  //   if(app.mode){
  //     if (!!this.bottombarState && this.bottombarState.selectedMode === app.name) {
  //       this.appStateSrv.setBottombarState({
  //         ...this.bottombarState,
  //         selectedMode: null,
  //       });
  //     } else {
  //       this.appStateSrv.setBottombarState({
  //         ...this.bottombarState,
  //         selectedMode: app.name
  //       });
  //     }
  //   }else{
  //     if (!!this.bottombarState && this.bottombarState.selectedApplication === app.name) {
  //       this.appStateSrv.setBottombarState({
  //         ...this.bottombarState,
  //         selectedApplication: null,
  //         selectedAppInfo: null
  //       });
  //     } else {
  //       this.appStateSrv.setBottombarState({
  //         ...this.bottombarState,
  //         position: this.bottombarConfig.position,
  //         selectedApplication: app.name,
  //         selectedAppInfo: app,
  //       });
  //     }
  //   }
  // }
  ngOnDestroy(){
    // this.subscriptions.forEach(s => s.unsubscribe());
  }
}
